import React, { useContext, useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { FormField } from '../../global/components/form-element/form-field';
import { getFormattedDate } from '../../global/helpers/date-helpers';
import { Filter, FilterTypes, SearchAppContext } from '../models/search-models';
import { addFilterByApp } from '../slices/backend-search-slice';
import { filterAccordionStyles } from '../../global/constants/theme/styles/pages/search/search-filter-accordion';


export interface Props {
	filterTitle: string,
	expand?: boolean,
	hideType?: boolean,
	dateLabel?: string,
}
export const submitted = 'Submitted';
export const effective = 'Effective';
export function DateTypeFilter(props: Props) {
	const app = useContext(SearchAppContext);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
	const selectedFilters = useSelector<TcsmStates, Filter[]>(state => state?.backendSearchStates[app]?.seletedFilters?.filter(f => f?.type === FilterTypes.from || f?.type === FilterTypes.to));
	const [dateType, setDateType] = useState(props?.hideType ? '' : submitted);
	const [from, setFrom] = useState(null);
	const [to, setTo] = useState(null);
	const [expand, setExpand] = useState(props?.expand);
	const dispatch = useDispatch();
	const accordionClasses = filterAccordionStyles();

	useEffect(() => {
		setExpand(props?.expand);
	}, [props?.expand]);


	useEffect(() => {
		if (!selectedFilters?.some(f => f?.type === FilterTypes.from)) {
			setFrom(null);
		}
		if (!selectedFilters?.some(f => f?.type === FilterTypes.to)) {
			setTo(null);
		}
	}, [selectedFilters?.length]);

	const handleChange = (evt) => {
		setDateType(evt?.target?.value);
		dispatch(addFilterByApp({ type: FilterTypes.dateType, value: `${evt?.target?.value}` }, app, true));

		if (from) {
			dispatch(addFilterByApp({ type: FilterTypes.from, value: `${evt?.target?.value}:${from}` }, app, true));
		}

		if (to) {
			dispatch(addFilterByApp({ type: FilterTypes.to, value: `${evt?.target?.value}:${to}` }, app, true));

		}
	};

	const handleOnBlur = (e, fromField: boolean) => {
		const value = e instanceof Date ? getFormattedDate(e?.toISOString()) : e?.target?.value;
		if (fromField) {
			setFrom(value);
			dispatch(addFilterByApp({ type: FilterTypes.from, value: `${dateType}:${value}` }, app, true));
		} else {
			setTo(value);
			dispatch(addFilterByApp({ type: FilterTypes.to, value: `${dateType}:${value}` }, app, true));
		}
	};

	return (
		<Accordion className={`${accordionClasses.filterAccordionitem} filter-accordion-item`} expanded={expand} onChange={()=>setExpand(!expand)}>
			<AccordionSummary
				className='filter-accordion-summary'
				expandIcon={<ExpandMoreIcon />}
			>
				<legend className='h4-styled'>{props?.filterTitle} <span className={selectedFilters?.length === 0 ? 'disabled-text' : ''}>{`(${selectedFilters?.length > 0 ? 1 : 0})`}</span></legend>
			</AccordionSummary>
			<AccordionDetails className='filter-accordion-details'>
				{
					!props?.hideType &&
					<FormControl component='fieldset'>
						<RadioGroup aria-label={searchSettings?.employeeChangeLogDateTypeLabel} value={dateType} onChange={handleChange}>
							<FormControlLabel className='input-label' value={submitted} control={<Radio />} label={searchSettings?.dateTypeSubmittedLabel} />
							<FormControlLabel className='input-label' value={effective} control={<Radio />} label={searchSettings?.dateTypeEffectiveLabel} />
						</RadioGroup>
					</FormControl>
				}
				<Formik
					enableReinitialize
					initialValues={{ from_date: from, to_date:to }}
					onSubmit={null}
				>
					{() => (
						<Form>
							{
								props?.dateLabel && <p>{props?.dateLabel}</p>
							}
							<FormField
								name={FilterTypes.from}
								label={searchSettings?.fromLabel}
								component='datePicker'
								autoWidth
								onBlur={(e) => handleOnBlur(e, true)}
							/>
							<FormField
								name={FilterTypes.to}
								label={searchSettings?.toLabel}
								component='datePicker'
								autoWidth
								onBlur={(e) => handleOnBlur(e, false)}
							/>
						</Form>)}
				</Formik>
			</AccordionDetails>
		</Accordion>
	);
}


DateTypeFilter.defaultProps = {
	expand: true,
	hideType: false,
	dateLabel: '',
};